var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { Fragment, useEffect, useState } from "react";
import { TextField } from "@atlassiansox/microscopekit";
import { useMutationUI } from "../../hooks";
import Modal, { ModalBody, ModalFooter, ModalTransition } from "@atlaskit/modal-dialog";
import SectionMessage from "@atlaskit/section-message";
import Button, { LoadingButton } from "@atlaskit/button";
import Form, { Field, FormFooter, FormHeader, FormSection } from "@atlaskit/form";
import styled from "styled-components";
import { EditCronosConfigMutation } from "../../graphql";
import { NumberField } from "../FormView/common";
import { isConfigDisabled, isFailaConfig } from "../../utils/cronos";
var getEditConfigContent = function (config) {
    return isFailaConfig(config)
        ? "UI editing is disabled. Your service currently has a Faila resource configured via SD. For instructions on how to fix, please refer"
        : "UI editing is disabled. Continous-Chaos resource is currently disabled for your service via SD file. For instructions on how to fix, please refer";
};
export var ConfigDetailsEditModal = function (_a) {
    var configDetails = _a.configDetails, isOpen = _a.isOpen, setIsOpen = _a.setIsOpen;
    var _b = __read(useState(configDetails.probability), 2), probability = _b[0], setProbability = _b[1];
    var _c = __read(useState(configDetails.schedule), 2), schedule = _c[0], setSchedule = _c[1];
    useEffect(function () {
        setProbability(configDetails.probability);
        setSchedule(configDetails.schedule);
    }, [configDetails]);
    var closeModal = function () {
        setProbability(configDetails.probability);
        setSchedule(configDetails.schedule);
        setIsOpen(false);
    };
    var _d = useMutationUI({
        mutation: EditCronosConfigMutation,
        successMessage: "Configuration in " + configDetails.environment + " env is successfully edited",
        options: {
            variables: {
                id: configDetails.id,
                updateConfigInput: {
                    parameters: configDetails.parameters,
                    probability: probability,
                    schedule: schedule
                }
            }
        }
    }), mutateEditConfig = _d.mutate, isLoading = _d.isLoading;
    return (React.createElement(ModalTransition, null, isOpen && (React.createElement(Modal, { onClose: closeModal },
        React.createElement(ModalBody, null,
            React.createElement(Container, null,
                React.createElement("div", null,
                    React.createElement(Form, { onSubmit: function () { } }, function (_a) {
                        var formProps = _a.formProps;
                        return (React.createElement("form", __assign({}, formProps, { id: "config-details" }),
                            React.createElement(FormHeader, { title: "Configuration Details" }),
                            isConfigDisabled(configDetails) && (React.createElement(Container, null,
                                React.createElement(SectionMessage, { appearance: "error" },
                                    React.createElement("p", null,
                                        getEditConfigContent(configDetails),
                                        "\u00A0",
                                        React.createElement("a", { href: "http://go/continuous-chaos-runbook", target: "_blank", rel: "noopener noreferrer" }, "http://go/continuous-chaos-runbook"))))),
                            React.createElement(FormSection, null,
                                React.createElement(Field, { label: "Fault Type", name: "faultType", isRequired: true }, function (_a) {
                                    var fieldProps = _a.fieldProps;
                                    return (React.createElement(Fragment, null,
                                        React.createElement(TextField, __assign({}, fieldProps, { isRequired: true, placeholder: configDetails.faultType, isDisabled: true }))));
                                }),
                                React.createElement(Field, { label: "Environment", name: "environment", isRequired: true }, function (_a) {
                                    var fieldProps = _a.fieldProps;
                                    return (React.createElement(Fragment, null,
                                        React.createElement(TextField, __assign({}, fieldProps, { isRequired: true, placeholder: configDetails.environment, isDisabled: true }))));
                                }),
                                React.createElement(Field, { name: "probability", isRequired: true }, function (_a) {
                                    var fieldProps = _a.fieldProps;
                                    return (React.createElement(Fragment, null,
                                        React.createElement(NumberField, __assign({}, fieldProps, { label: "Probability", value: probability, isRequired: true, isDisabled: isConfigDisabled(configDetails), onChange: function (value) {
                                                setProbability(value);
                                            } }))));
                                }),
                                React.createElement(Field, { label: "Schedule", name: "schedule", isRequired: true }, function (_a) {
                                    var fieldProps = _a.fieldProps;
                                    return (React.createElement(Fragment, null,
                                        React.createElement(TextField, __assign({}, fieldProps, { value: schedule, onChange: function (event) {
                                                setSchedule(event.target.value);
                                            }, isDisabled: isConfigDisabled(configDetails), isRequired: true }))));
                                })),
                            React.createElement(FormFooter, null,
                                React.createElement(Button, { appearance: "subtle", onClick: closeModal }, "Close"),
                                React.createElement(LoadingButton, { type: "submit", appearance: "primary", isDisabled: (probability && schedule ? false : true) ||
                                        isConfigDisabled(configDetails), onClick: function () {
                                        mutateEditConfig();
                                    }, isLoading: isLoading, autoFocus: true }, "Save"))));
                    })))),
        React.createElement(ModalFooter, null)))));
};
export var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin-top: 10px;\n"], ["\n  margin-top: 10px;\n"])));
var templateObject_1;
